// 认证数据模型，与后端字段命名对齐。
import type { PointBalance } from '@/shared/model/point-balance';

export type AuthMode = 'unknown' | 'guest' | 'authenticated';

export interface AuthApiUserInfo {
  token?: string;
  team_id?: string;
  team_name?: string;
  member_role?: string;
  ai_watermark?: number;
  uuid?: string;
  nickname?: string;
  avatar?: string;
  type?: number;
  tel?: string;
  account?: string;
  point?: number;
  point_total?: number;
  is_vip?: number;
  visitor?: string;
  chat_token?: string;
  [key: string]: unknown;
}

export interface IDefaultTTS {
  collect: number,
  data: any,
  id: string,
  img: string,
  name: string,
  preview: string,
  res_v: number,
  type: string,
  url: string,
}

export interface AliyunOSSInfo {
  accessKeyId: string;
  accessKeySecret: string;
  expiration: string;
  securityToken: string;
}

export interface OSSToken {
  aliyun: AliyunOSSInfo;
  domain: string;
  endpoint: string;
  expired: number;
  prefix: string;
  region: string;
}

export interface AuthApiCurrentTeam {
  token?: string;
  team_id: string;
  team_name: string;
  team_avatar?: string;
  team_kind?: string;
  current_plan_type?: string;
  plan_name?: string;
  plan_status?: string;
  concurrency_limit?: number;
  is_personal_team?: number;
  collaboration_enabled?: number;
  member_role: string;
  grace_expire_time?: number;
  seat_status?: string;
  has_valid_seat?: number;
  enter_mode?: string;
  ai_watermark?: number;
  point_limit_month?: number;
  point_used_month?: number;
  point_remain_month?: number;
  team_point_limit_month?: number;
  point_balance_permanent?: number;
  point_balance?: PointBalance;
}

export interface AuthApiLoginData {
  server_time: number;
  user_info?: AuthApiUserInfo;
  redirect?: Record<string, string>;
  canvas_urls?: Record<string, string>;
  // cdn_config?: Record<string, string>;
  canvas_config?: {
    default_tts: IDefaultTTS;
  };
  /** /login 接口下发的翻译目标语言选项列表 */
  translate_lang?: { value: string; label: string }[];
  oss_token: OSSToken;
  current_team?: AuthApiCurrentTeam;
}

export interface AuthQrTicketData {
  ticket: string;
}

function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return null;
  }
  return value as Record<string, unknown>;
}

export function resolveAuthMode(loginData: AuthApiLoginData | null | undefined): AuthMode {
  const token = loginData?.user_info?.token || '';
  if (!token) {
    return 'unknown';
  }

  if ((loginData?.user_info?.type || 0) !== 0) {
    return 'authenticated';
  }

  return 'guest';
}

export function parseStoredLoginData(value: unknown): AuthApiLoginData | null {
  const record = asRecord(value);
  if (!record) {
    return null;
  }

  const userInfo = asRecord(record.user_info);
  const token = typeof userInfo?.token === 'string' ? userInfo.token : '';
  if (!token) {
    return null;
  }

  return {
    ...record,
    user_info: userInfo as AuthApiUserInfo,
  } as unknown as AuthApiLoginData;
}
